import type { Fallacy } from "./types";
import { createStory } from "./types";

export const slipperySlope: Fallacy = {
    id: "slippery-slope",
    name: "Slippery Slope",
    emoji: "⛷️",
    category: "Logika Rusak",
    description:
      "Berargumen bahwa satu langkah kecil pasti akan menyebabkan **rangkaian kejadian buruk yang ekstrem**, tanpa bukti.",
    detail:
      "Slippery Slope adalah argumen bahwa satu tindakan kecil akan memicu **serangkaian konsekuensi yang semakin buruk**. Strukturnya: Jika A terjadi, maka B, lalu C, lalu D... sampai bencana Z. Padahal tidak ada bukti rantai itu pasti terjadi.\n\nKenapa ini fallacy? Karena setiap langkah dalam rantai itu bisa dihentikan atau dicegah. **Tidak ada hukum alam yang mengharuskan A mengarah ke Z.**\n\nPerlu dicatat: Tidak semua argumen rantai kausalitas itu fallacy. Kalau setiap langkahnya didukung bukti kuat, itu argumen valid. Yang jadi fallacy adalah ketika koneksi antar langkah hanya berdasarkan asumsi dan ketakutan.",
    tldr: "Satu langkah kecil langsung diramal jadi bencana? Lebay banget, itu Slippery Slope.",
    story: createStory("Slippery Slope", "⛷️", {
      hook: {
        title: "Kamu cuma usul hal kecil...",
        body: "Tapi langsung diramal jadi **bencana besar**. Seolah satu langkah kecil pasti berujung kehancuran.",
      },
      convo: {
        claim: "Main game 1 jam? Nanti ketagihan, nilai jeblok, putus sekolah. **Satu langkah aja udah jadi bencana!**",
        response: "Setiap langkah dalam rantai itu **bisa dihentikan.** Main game 1 jam gak otomatis bikin putus sekolah.",
      },
      reveal: {
        body: "Satu tindakan kecil langsung diramal memicu **rantai kejadian buruk yang ekstrem**. Padahal gak ada bukti rantai itu pasti terjadi.",
      },
      insight: {
        title: "Kenapa lebay?",
        body: "Setiap langkah dalam rantai itu **bisa dihentikan**. Main game 1 jam gak otomatis bikin putus sekolah — itu lompatan tanpa bukti.",
      },
      engagement: {
        title: "Ramalan doom paling lebay yang pernah kamu denger?",
        body: "Dari ortu, guru, atau bos? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["false-dilemma", "appeal-to-emotion", "hasty-generalization"],
  };
